
import listings from './listings'
import listingsFilter from './listings.filter'
import listingsPagination from './listings.pagination'

const self = {


  updateResults : e => {
    console.log( `updateResults` );


    self.clearResults()
    listingsPagination.reset()
    listingsPagination.setNextPage()

    listingsFilter.getResultsFromDB()
      .then( res => res.json() )
      .then( json => {
        listings.store(json)
        listingsFilter.setMarkerVisibility()
        self.setError({})

        console.log( `Results JSON:`, json.docs )

        return listings.createArticlesFrom({ listings : json.docs })
      })
      .then( success => listingsPagination.enable() )

      .catch( err => {
        console.log('rejecting promise', err);
        return self.setError({ action : 'add', msg : err.msg })
      })
  },

  setError : ({ action = 'remove', msg = '' }) => {
    console.log('setting error message', action, msg);
    const errorElm = document.querySelector('.listings-results .error')
    errorElm.innerHTML = msg
    errorElm.classList[action]('show')
  },

  appendResults : () => new Promise( (resolve, reject) => {
    listingsPagination.setNextPage()

    listingsFilter.getResultsFromDB()
      .then( res => res.json() )
      .then( json => {
        console.log(json);
        if ( json.docs.length < listingsPagination.perPage ) {
          return listingsPagination.noMoreResults()
        }

        listings.store(json)
        return listings.createArticlesFrom({ listings : json.docs })
      })
      .then( success => {
        listingsPagination.enable()
        resolve(true)
      })
  }),

  clearResults : () => {
    listings.elms.articleContainer.innerHTML = ''
  },

  // filterListings : () => {
  //   listings.totalActiveListings = 0
  //
  //   for (let listing of listings.listings) {
  //     const shouldBeVisible = self.shouldSetListingVisible(listing)
  //
  //     // shouldBeVisible is true or false, setting the display appropriatly
  //     listing.marker.setVisible(shouldBeVisible)
  //
  //     // Hide or show the given listing
  //     self.toggleArticleDisplay(listing.el, shouldBeVisible)
  //
  //     // Keep track of the shown listings when filtering
  //     if (shouldBeVisible) {
  //       listings.totalActiveListings += 1
  //       listing.el.classList.remove('ft-hidden')
  //     } else {
  //       listing.el.classList.add('ft-hidden')
  //     }
  //   }
  //
  //   listings.map.infowindow.close()
  //   //listingsPagination.reset()
  //   listings.map.markerCluster.repaint()
  //
  //   return listingsFilter.setTotalListingsDisplay()
  // },


  shouldSetListingVisible : listing => {
    let filterCondition, listingVal, filterVal, isLessThanMin, isGreaterThanMax, valueOrMore, minValueOrMore, maxValueOrMore

    for (let filterKey in listings.activeFilters) {
      if (!listings.activeFilters.hasOwnProperty(filterKey)) continue
      listingVal  = listing.acf[filterKey]
      filterVal   = listings.activeFilters[filterKey]

      switch (filterKey) {

        // Price Range
        case 'price':
          listingVal          = parseInt(listingVal)

          if (filterVal.max) {
            maxValueOrMore    = filterVal.max.search(/(\+)/g) !== -1
            isLessThanMin     = listingVal < parseInt(filterVal.min)
            isGreaterThanMax  = listingVal > parseInt(filterVal.max)
            filterCondition   = (maxValueOrMore) ? isLessThanMin : isLessThanMin || isGreaterThanMax
          } else {
            filterCondition   = listingVal < parseInt(filterVal.min)
          }
        break;

        // Test if listing value is less that the filter value
        case 'total_bedrooms' :
        case 'total_bathrooms' :
          valueOrMore     = filterVal.search(/(\+)/g) !== -1
          listingVal      = (valueOrMore) ? parseInt(listingVal) : listingVal
          filterVal       = (valueOrMore) ? parseInt(filterVal) : filterVal
          filterCondition = (valueOrMore) ? listingVal < filterVal : listingVal !== filterVal
        break;

        // Matches listings by mls number from an array
        case 'mls_number' :
          filterCondition = filterVal.indexOf(listingVal) === -1
        break;

        //
        case 'address' :
          const matches = filterVal.map( val => {
            const re = new RegExp(val, 'i')
            return listingVal.search(re) !== -1
          })

          filterCondition = matches.indexOf(true) === -1
        break;

        // Compare if strings are equal
        default :
          filterCondition = (filterVal === 'all') ? false : listingVal !== filterVal
      }

      if (filterCondition) return false
    }

    return true
  },


  toggleArticleDisplay : (article, shouldBeVisible) => {
    const cls = 'ft-hidden'
    const articleIsHidden = article.classList.contains(cls)

    if (shouldBeVisible && articleIsHidden) return article.classList.remove(cls)
    if (!shouldBeVisible && !articleIsHidden) return article.classList.add(cls)
  },


  getInfoWindowHTML : listing => {
    const price = parseInt(listing.acf.price).toLocaleString()
    const totalArea = parseInt(listing.acf.total_area).toLocaleString()
    const address = self.getAddressFrom(listing).replace(' VE','').replace(' VW','')
    const slug = self.getSlugFrom(listing)
    const img = ( listing.acf.gallery ) ? listing.acf.gallery[0].sizes.medium : ''

    return `
      <div class="iw">
        <div class="iw__image">
          <div class="bg-image" style="background-image:url(${img});"></div>
        </div>
        <div class="iw__info">
          <div class="wrap">
            <span class="iw__title"><a class="iw__link" href="${slug}">${address}</a></span>

            <div class="iw__meta">
              <span class="bedrooms">${listing.acf.total_bedrooms} <i class="material-icons">local_hotel</i></span>
              <span class="bathrooms">${listing.acf.total_bathrooms} <i class="material-icons">hot_tub</i></span>
              <span class="area">${totalArea} sq. ft.</span>
              <span class="brokerage">${listing.acf.organization_name}</span>
            </div>

            <span class="iw__price">$${price}</span>
            <a class="iw__link" href="${slug}">View Listing</a>
          </div>
        </div>
      </div>
    `
  },


  getListingArticleHTML : ({ listing, lazyLoad = true, hideForPagination = true }) => {
    const maxChars = 150
    const acf = listing.acf
    const address = self.getAddressFrom(listing)
    const slug = self.getSlugFrom(listing)
    const price = `$${parseInt(acf.price).toLocaleString()}`
    const totalArea = parseInt(acf.total_area).toLocaleString()
    const img = ( acf.gallery[0] ) ? acf.gallery[0].sizes.large : ''
    const totalBedrooms = (acf.total_bedrooms === '0') ? `studio` : `${acf.total_bedrooms} bedrooms`
    const imgAttr = (lazyLoad) ? `data-image="${img}"` : `style="background-image:url(${img});"`
    const isSold = acf.is_sold === true

    // Format the description if it's too long
    let description = acf.description
    if ( description && description.length > maxChars ) description = `${ description.substring(0, maxChars) }...`

    const article = document.createElement('article')
          article.className = 'columns'

    const figure = document.createElement('figure')
          figure.className = 'column'
          figure.setAttribute('rel', '2')
          figure.innerHTML = `
            <div class="bg-image" ${imgAttr}></div>
          `

    const aside = document.createElement('aside')
          aside.className = 'column'
          aside.setAttribute('rel', '2')

          if (isSold) {
            aside.innerHTML = `
              <div class="tags">
                <span class="tag">Sold</span>
              </div>
            `
          }

          aside.innerHTML += `
            <h3>
              <span class="listing-address">${address}</span>
              <span class="listing-price">${price}</span>
            </h3>

            <div class="details">
              <span class="detail-bedrooms">${totalBedrooms}</span>
              <span>&mdash;</span>
              <span class="detail-bathrooms">${acf.total_bathrooms} bathrooms</span>
              <span>&mdash;</span>
              <span class="detail-total-area">${totalArea} sq. ft.</span>

              <span class="btn dark-circle wishlist">
                <button class="simplefavorite-button" data-postid="${listing.id}" data-siteid="1" data-groupid="1" data-favoritecount="0" style="">
                  <i class="sf-icon-star-empty"></i>
                  <span>Favorite</span>
                </button>
              </span>

              <span class="listed-by">Listed By: ${acf.organization_name}</span>
            </div>

            <div class="description"><p>${description}</p></div>
            <a href="${slug}" class="btn underline">Further Details</a>
          `

    article.appendChild(figure)
    article.appendChild(aside)

    return article
  },


  getAddressFrom : listing => {
    let address = ''

    // Extract the nedded properties
    const {
      address_unit,
      address_number,
      address_street,
      street_designation,
      neighbourhood
    } = listing.acf

    // If the listing has a unit number, start with that
    if ( address_unit ) address += `${address_unit} - `

    // Add the street address, should always be set
    address += `${address_number} ${self.lowerCaps(address_street)} ${self.lowerCaps(street_designation)}, `

    // Add the neighbourhood and remove VW, applies to Downtown VW and West End VW
    address += neighbourhood.replace('VW', '')

    return address
  },


  getSlugFrom : listing => {
    return `/public/${listing.slug}`
  },


  lowerCaps : string => {
    string = string.toLowerCase()
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`
  }
}

export default self
